import useShortcut from '../../services/shortcuts/useShortcut';

/**
 * ctrl+L - ⌘L on a Mac - goes to the track that is playing: the playlist it
 * was started from, scrolled to it, with it selected. iTunes called this
 * "Go to Current Song", and it was the shortcut worth keeping.
 *
 * The same division of labour as the space hook: this declares the key, the
 * player owns what happens.
 *
 * In a browser tab ctrl+L is the address bar, and the page taking it is the
 * point rather than a side effect - a shortcut that works only sometimes is
 * not one. It is taken only when there is somewhere to go, so with nothing
 * playing the key is still the browser's. Installed as an app there is no
 * address bar to lose.
 *
 * Text boxes do not keep it, unlike space: ctrl+L types nothing, and the
 * filter box is exactly where one might be when the wish to find the track
 * that is playing arrives.
 */
export default function useGoToCurrentTrackShortcut(
  /** Goes to the current track. Returns false when there is nowhere to go. */
  goToCurrentTrack: () => boolean,
) {
  useShortcut({
    id: 'go-to-current-track',
    keys: { key: 'l', mod: true },
    group: 'Playback',
    description: 'Go to the track that is playing',
    whileTyping: true,
    run: () => goToCurrentTrack(),
  });
}
